import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { IdentityStore, IdentityStoreType } from '@appState/identity/identity.store';
import { Observable, filter, map, switchMap } from 'rxjs';

export const AuthGuard = (): Observable<boolean> => {
  const identityStore: IdentityStoreType = inject(IdentityStore);
  const router: Router = inject(Router);

  const isAuthenticated = toObservable(identityStore.isAuthenticated);
  const isLoading = toObservable(identityStore.isLoading);

  return isLoading.pipe(
    filter(isLoading => isLoading !== true),
    switchMap(() =>
      isAuthenticated.pipe(
        map(isAuthenticated => {
          if (!isAuthenticated && window.location.pathname !== '/') {
            localStorage.setItem('redirectUri', window.location.pathname);
            return false;
          }

          const redirectUri = localStorage.getItem('redirectUri');
          if (redirectUri) {
            localStorage.removeItem('redirectUri');
            router.navigateByUrl(redirectUri);
          }

          return true;
        }),
      ),
    ),
  );
};
